module.exports = __webpack_public_path__ + "img/ai4@2x.c92a3062.png";